<template>
  <div
    class="modal-card has-text-centered"
    style="max-width: 800px; width: auto; margin: auto;"
  >
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("users.reason") }}
      </p>
    </header>

    <section class="modal-card-body">
      {{ details.reason }}
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        class="button is-deep-purple"
        type="button"
        @click="unblockUser"
        v-if="permissions.unblockClient"
      >
        {{ $t("users.unblockUser") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  props: ["details"],

  mixins: [common],

  methods: {
    unblockUser() {
      this.$buefy.dialog.confirm({
        message: this.$t("users.confirmUserUnblock"),
        confirmText: this.$t("common.yes"),
        cancelText: this.$t("common.cancel"),
        type: "is-deep-purple",
        onConfirm: () => {
          this.isLoading = true;
          this.$store
            .dispatch("unblockUser", {
              userId: this.details.user._id
            })
            .then(res => {
              if (res.data.result === "error") {
                this.alertError(res.data);
              } else {
                this.$buefy.toast.open({
                  message: this.$t("users.userUnblocked"),
                  type: "is-success",
                  position: "is-bottom",
                  duration: 5000
                });
                this.$parent.close();
              }
            })
            .catch(() => {
              this.alertError({ message: "UNEXPECTED_ERROR" });
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    }
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>
